import { useContext } from "react";
import { ProductFilterType } from "../../../configs/filterTypes";
import { Search, TableColumns } from "../../../configs/products";
import { ProductSortTypes } from "../../../configs/sortTypes";
import { ROLE } from "../../../data/enums";
import { AuthenticationContext } from "../../../provider/AuthenticationProvider";
import ListView from "../../../shared/components/ListView";
import { ProductRow } from "./ProductTable";

const Content = () => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);

    const getTableColumns = () => {
        switch (role) {
            case ROLE.LOGISTIC_STAFF:
            case ROLE.PURCHASING_STAFF:
            case ROLE.PRODUCTION_STAFF:
            case ROLE.STORAGE_KEEPER:
            case ROLE.FIRST_STORAGE_KEEPER:
            case ROLE.SECOND_STORAGE_KEEPER:
                return TableColumns.filter(({ text }) => !["Giá", "Kho số"].includes(text));
            case ROLE.FACTORY_MANAGER_ONE:
            case ROLE.FACTORY_MANAGER_TWO:
            case ROLE.DEPUTY_FACTORY_MANAGER_ONE:
            case ROLE.DEPUTY_FACTORY_MANAGER_TWO:
            case ROLE.DELIVERER:
                return TableColumns.filter((item) => item.text !== "Giá");
            case ROLE.SALE_MANAGER:
            case ROLE.LOGISTIC_MANAGER:
            case ROLE.SALE_STAFF:
            case ROLE.MANAGER:
            case ROLE.ACCOUNTANT_MANAGER:
            case ROLE.FACTORY_STAFF:
                return TableColumns;
        }
    };

    return (
        <ListView
            url="/products/"
            sortTypes={ProductSortTypes}
            filterTypes={ProductFilterType}
            rowElement={ProductRow}
            tableColumns={getTableColumns()}
            textString={Search.searchText}
        />
    );
};

export default Content;
